
import { Component, Vue } from 'vue-property-decorator'
import TixStepper from '@/components/forms/TixStepper.vue'
import FormInput2 from '@/components/forms/FormInput2.vue'
import AutocompleteInput from '@/components/forms/AutocompleteInput.vue'
import Tabs from '@/components/elements/Tabs.vue'

@Component({ name: 'ElementsStory', components: { FormInput2, TixStepper, AutocompleteInput, Tabs } })
export default class extends Vue {
  mounted() {
    const autocomplete = this.$refs.autocomplete as Vue
    const address = autocomplete.$el.getElementsByClassName('autocomplete-list-item')[1]
    address.setAttribute('class', address.getAttribute('class') + ' hover')
  }
}
